import { pdfjs } from 'react-pdf';

// Set worker path to local file
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';

export default pdfjs;
